import logoIcon from '@/assets/icons/logo.png'

type TecmaLogoProps = {
  className?: string
  dark?: boolean
}

export default function TecmaLogo({ className = '', dark = false }: TecmaLogoProps) {
  return (
    <span className={`inline-flex items-center ${dark ? 'text-[#131a54]' : 'text-white'} ${className}`.trim()}>
      <img src={logoIcon} alt="" aria-hidden="true" className="h-[42px] w-[35px] shrink-0 object-contain" />
      <span className="tecma-brand-wordmark ml-[5px] leading-none">
        <strong className="block text-[21px] font-medium tracking-[-0.02em]">TECMA</strong>
        <span className="mt-[1px] block text-[15px] tracking-[0.015em]">CARIBE</span>
      </span>
    </span>
  )
}
